import Vue from 'vue'
import './pollyfills'
import VueRouter from 'vue-router'
import VueRouterPrefetch from 'vue-router-prefetch'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import App from './App.vue'


// Services
import ApiService from './services/api.service'
import { TokenService } from './services/storage.service'



// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'
import initProgress from './progressbar';

// router setup
import routes from './routes/routes'

// library imports

import './assets/sass/paper-dashboard.scss'
import './assets/sass/demo.scss'

import sidebarLinks from './sidebarLinks'


  
import './registerServiceWorker'
// plugin setup
Vue.use(VueRouter)
Vue.use(VueRouterPrefetch)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, {sidebarLinks: sidebarLinks})



Vue.use(VeeValidate)
locale.use(lang)

//Vue.prototype.$base_url = "http://csp.thefrontalgroup.com:8000";
//Vue.prototype.$base_url = "https://csp.thefrontalgroup.com/cs/public";
//Vue.prototype.$base_url = "https://api-cs.easilycorp.com/csp/cs/public";

Vue.prototype.$base_url = process.env.VUE_APP_API_PATH
Vue.prototype.$cs_app_name = process.env.VUE_APP_NAME



//populate commonly used variables !! - to move to common.service 
Vue.prototype.$entity_status = [
            {value: 1, label: 'Live'},
            {value: 2, label: 'Dormant'},
            {value: 3, label: 'Struck Off'},   
            {value: 4, label: 'Dropped'},
            {value: 5, label: 'Onboarding'},   
		   ];

Vue.prototype.$entity_type =[
            {value: 1, label: 'Private Company Limited By Shares'},
            {value: 2, label: 'Business'},
            {value: 3, label: 'Limited Liability Partnership (LLP)'},
            {value: 4, label: 'Limited Partnership (LP)'},
            {value: 5, label: 'Sole-Proprietorship'},
            {value: 6, label: 'Partnership'},
            {value: 7, label: 'Public Company Limited By Guarantee'},
		   ];





// Set the base URL of the API
ApiService.init(process.env.VUE_APP_ROOT_API)

// If token exists set header
if (TokenService.getToken()) {
  ApiService.setHeader()
}


// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  }
})



router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
  const loggedIn = !!TokenService.getToken();


  
  if (!isPublic && !loggedIn) {
    return next({
      path:'/login',
      query: {redirect: to.fullPath}  // Store the full path to redirect the user to after login
    });
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next('/')
  }

  next();
})

initProgress(router);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router
})
